<template>
  <div id="list-informations-new" class="list-informations-new"     :style="[{ marginLeft: marginLeft }]">

    <b-row class="content" v-if="this.$route.name === 'segment' && slide !== null">
      <div  class="arrow-panel imgClickAndChange" @click="showPanel" >
        <i class="fa fa-angle-down"></i>
      </div>
      <span style="    margin-left: 10px;" v-if="slide">
        {{ $t('panels.infos.name_screen') }}
      {{ slide.title }} | {{ $t('panels.infos.duration_screen') }}
      {{ slide.options.duration | FormatTime }}
      
      </span>
    </b-row>
    <b-row
      class="content"
      v-if="this.$route.name !== 'segment' && segment !== null"
    >
      <div  class="arrow-panel imgClickAndChange" @click="showPanel" >
        <i class="fa fa-angle-down"></i>
      </div>
      <span style="    margin-left: 10px;"  v-if="paramsClient.nb_screen_segment!==1">
      {{ $t('panels.infos.name_segment') }}
      {{ segment.title }} | {{ $t('panels.infos.name_screen') }}{{ slide.title }} |
      {{ $t('panels.infos.duration_segment') }}
      {{ segment.duration | FormatTime }}
        </span>

      <span style="    margin-left: 10px;"  v-if="paramsClient.nb_screen_segment===1" >
      {{ $t('panels.infos.name_screen') }}{{ slide.title }} |
      {{ $t('panels.infos.duration_screen') }}
      {{ FormatTime }}
        </span>

    </b-row>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
export default {
  name: 'InformationsNew',
  data: function() {
    return {
      marginLeft: 0,
    };
  },
  computed: {
    /**
     * Getters from Vuex Store
     */
    ...mapGetters({
      segment: 'segments/getCurrent',
      slide: 'slides/getCurrent',
      paramsClient: 'getParamsClients',

    }),
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
    console.log("valuess ", this.segment)
  },
  methods: {
    handleResize() {
      setTimeout(() => {
        var p = document.querySelector('.gjs-frame');
        this.marginLeft = p.offsetLeft + 20 + 'px';
        // this.marginRight =p.offsetParent.offsetWidth - p.offsetLeft  + 20 + 'px';
        console.log("valeeeuuss", this.segment)
      }, 1000);
    },
    showPanel() {
      this.$root.$emit('showPanel');
    },
  }
};
</script>

<style lang="scss" scoped>
  @import '../scss/variables';
.list-informations-new {
  display: block;
  position: absolute;
  bottom: $height-custom-panel;
  z-index: 7;
  left: 0;
  text-align: left;
  color: #6f7982 !important;
  font-size: 10px;
  font-family: sans-serif;
}
.list-informations-new.rotate{
  bottom: 0px;
}
.arrow-panel {
  position: relative;
  z-index: 555;
  cursor: pointer;
  background: #ffffff;
  border-top-left-radius: 50%;
  border-top-right-radius: 50%;
  transition: 0.15s ease-in-out;
  width: 30px;
  padding: 4px;
  height: 20px;
  bottom: 0px;
  margin: 0 auto;
  left: 0;
  right: 0;
  z-index: 0;
  box-shadow: 0px -1px 2px rgba(0, 0, 0, 0.2);
  i:before {
    content: '\f0d7';
  }
  &.rotate {
    bottom: 5px;
    i {
      transform: rotate(180deg);
    }
  }
  i {
    transition: 0.15s;
    width: 25px;
    font-size: 20px;
    margin: -1px -1px;
    display: flex;
    justify-content: center;
  }
}

</style>



// WEBPACK FOOTER //
// InformationsCanvas.vue?39de93b4